import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    GroupValidateResponse,
    IconSize,
    IconType,
    SharedGroupValidationConflictFolder
} from '../../core-data-model';
import { Util } from '../../core-utilities';
import { TranslationService } from '../../translations';

@Component({
    selector: 'shared-groups-permission-modal',
    template: `
        <modal class="pi-modal modal-size-620">
            <div class="pi-modalHeader move-right layoutLastPushedRight-X">
                <div style="margin-left: 10px;">
                    <div class="layoutHorizontalSpaced" style="margin-top:40px">
                        <div>
                            <abstract-icon
                                class="warningText"
                                [iconType]="IconType.Warning2"
                                [iconSize]="IconSize.Large"
                            >
                            </abstract-icon>
                        </div>
                        <div style="margin-left: 20px">
                            <div class="title-lg">
                                {{ cardHeaderText }}
                            </div>

                            @for (
                                folder of validateResponse.problemFolders;
                                track folder
                            ) {
                                <div>
                                    <div
                                        class="layoutHorizontal"
                                        style="margin-top: 20px"
                                    >
                                        <div class="boldText">
                                            {{ folder.name }}
                                        </div>
                                        <div>
                                            -
                                            {{ getFolderContentString(folder) }}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div>
                        <div class="italicText" style="margin-top:20px">
                            {{ getWarningMessage() }}
                        </div>
                        @if (!isThirdPartyUser) {
                            <div
                                class="layoutHorizontalSpaceBetween"
                                style="margin-top:30px; margin-bottom:40px"
                            >
                                <button
                                    class="button button-tertiary button-md"
                                    (click)="
                                        closeWithNoAccess(
                                            validateResponse.userId
                                        )
                                    "
                                >
                                    {{ TR.key('teams.modal.donotshare') }}
                                </button>
                                <button
                                    class="button button-primary button-md"
                                    (click)="addUserAndAccess(validateResponse)"
                                >
                                    {{
                                        TR.key('personManagement.enableAccess')
                                    }}
                                </button>
                            </div>
                        } @else {
                            <div style="margin-top:30px; margin-bottom:40px">
                                <button
                                    class="button button-tertiary button-md"
                                    (click)="
                                        closeWithNoAccess(
                                            validateResponse.userId
                                        )
                                    "
                                >
                                    {{ TR.key('label.common-terms.close') }}
                                </button>
                            </div>
                        }
                    </div>
                </div>
                <button
                    type="button"
                    class="close"
                    (click)="closeWithNoAccess(validateResponse.userId)"
                    [title]="TR.key('text.common-terms.close')"
                >
                    <i
                        class="fa fa-close"
                        [title]="TR.key('text.common-terms.close')"
                    ></i>
                </button>
            </div>
        </modal>
    `,
    standalone: false
})
export class SharedGroupsPermissionModalComponent {
    @Input()
    validateResponse: GroupValidateResponse;

    @Input()
    isThirdPartyUser: boolean;

    @Output()
    closeModal: EventEmitter<any> = new EventEmitter();

    @Output()
    addUser: EventEmitter<any> = new EventEmitter();

    @Output()
    removeUser: EventEmitter<any> = new EventEmitter();

    IconType = IconType;
    IconSize = IconSize;
    constructor(
        public TR: TranslationService,
        private util: Util
    ) {}

    get cardHeaderText(): string {
        return this.util.strings.formatString(
            this.TR.key('groups.modal.missingAccessTo'),
            this.validateResponse.userName
        );
    }

    getWarningMessage() {
        return this.isThirdPartyUser
            ? this.TR.key('sharedTeams.thirdPartyFolderAccess-error')
            : this.TR.key('sharedGroups.addUsersToGroupWarning');
    }
    closeWithNoAccess(userId: string) {
        this.removeUser.emit(userId);
        this.closeModal.emit();
    }

    addUserAndAccess(validateResponse: GroupValidateResponse) {
        this.addUser.emit(validateResponse);
        this.closeModal.emit();
    }

    getFolderContentString(problemFolder: SharedGroupValidationConflictFolder) {
        return problemFolder.problemItems
            .sort((a, b) => {
                if (a.type == 'person' && b.type == 'job') {
                    return 1;
                }
                if (a.type == 'job' && b.type == 'person') {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                if (a.name < b.name) {
                    return -1;
                }
                return 0;
            })
            .map((item) => item.name)
            .join(', ');
    }
}
